(function () {
  var lockReasons = {};
  var blockerInstalled = false;
  var blockedEvents = ['click', 'pointerdown', 'pointerup', 'touchstart', 'touchend', 'keydown', 'submit', 'drop', 'dragover'];

  function isLocked() {
    return Object.keys(lockReasons).length > 0;
  }

  function installBlocker() {
    if (blockerInstalled) return;
    blockerInstalled = true;
    blockedEvents.forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (!isLocked()) return;
        var overlay = document.getElementById('pct-saving-ui-lock');
        if (overlay && overlay.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }, true);
    });
  }

  function ensureSavingStyle() {
    if (document.getElementById('pct-saving-ui-lock-style')) return;
    var style = document.createElement('style');
    style.id = 'pct-saving-ui-lock-style';
    style.textContent = [
      'body.pct-saving-ui-locked{overflow:hidden!important;}',
      '#pct-saving-ui-lock{position:fixed;inset:0;z-index:10000060;background:rgba(255,255,255,.72);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;font-family:inherit;pointer-events:auto;}',
      '#pct-saving-ui-lock .pct-saving-card{width:min(430px,calc(100vw - 42px));background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,.18);padding:30px;text-align:center;}',
      '#pct-saving-ui-lock .pct-saving-spinner{width:34px;height:34px;margin:0 auto 16px;border:3px solid #ececec;border-top-color:#2C3E35;border-radius:50%;animation:pctSavingSpin .75s linear infinite;}',
      '#pct-saving-ui-lock h2{margin:0 0 8px;font-size:22px;line-height:1.15;color:#151515;}',
      '#pct-saving-ui-lock p{margin:0;color:#555;font-size:14px;line-height:1.45;}',
      '#pct-upload-regenerate-modal{position:fixed;inset:0;z-index:10000055;background:rgba(0,0,0,.42);display:flex;align-items:center;justify-content:center;font-family:inherit;padding:22px;}',
      '#pct-upload-regenerate-modal .pct-upload-regenerate-card{width:min(450px,100%);background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,.22);padding:26px;}',
      '#pct-upload-regenerate-modal h2{margin:0 0 10px;font-size:22px;line-height:1.15;color:#151515;}',
      '#pct-upload-regenerate-modal p{margin:0 0 22px;color:#555;font-size:14px;line-height:1.5;}',
      '#pct-upload-regenerate-modal .pct-upload-regenerate-actions{display:flex;justify-content:flex-end;gap:10px;}',
      '#pct-upload-regenerate-modal button{border:0;border-radius:999px;padding:12px 18px;font-weight:800;cursor:pointer;}',
      '#pct-upload-regenerate-modal [data-pct-cancel]{background:#f1f1f1;color:#111;}',
      '#pct-upload-regenerate-modal [data-pct-continue]{background:#2C3E35;color:#fff;}',
      '@keyframes pctSavingSpin{to{transform:rotate(360deg)}}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureSavingOverlay(title, message) {
    ensureSavingStyle();
    var overlay = document.getElementById('pct-saving-ui-lock');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'pct-saving-ui-lock';
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.innerHTML = '<div class="pct-saving-card"><div class="pct-saving-spinner" aria-hidden="true"></div><h2 data-pct-saving-title></h2><p data-pct-saving-message></p></div>';
      document.body.appendChild(overlay);
    }
    var titleEl = overlay.querySelector('[data-pct-saving-title]');
    var messageEl = overlay.querySelector('[data-pct-saving-message]');
    if (titleEl) titleEl.textContent = title || 'Saving your design';
    if (messageEl) messageEl.textContent = message || 'Please wait while we finish this step.';
  }

  window.pctSetSavingUiLock = function (locked, options) {
    installBlocker();
    options = options || {};
    var reason = options.reason || 'default';
    if (locked) {
      lockReasons[reason] = true;
      ensureSavingOverlay(options.title, options.message);
      document.body.classList.add('pct-saving-ui-locked');
      return;
    }
    delete lockReasons[reason];
    if (!isLocked()) {
      var overlay = document.getElementById('pct-saving-ui-lock');
      if (overlay) overlay.remove();
      document.body.classList.remove('pct-saving-ui-locked');
    }
  };

  function hasRegeneratingLayout() {
    if (window.isAutoPreparingDesign || window.uploadBatchInProgress) return false;
    if (window.designConfirmed || window.hasAutoFilled) return true;
    if (window.autoDesignState === 'ready' || window.autoDesignState === 'error') return true;
    return Array.isArray(window.spreadMemory) && window.spreadMemory.length > 0;
  }

  window.pctConfirmRegeneratingUpload = function () {
    ensureSavingStyle();
    return new Promise(function (resolve) {
      var existing = document.getElementById('pct-upload-regenerate-modal');
      if (existing) existing.remove();
      var modal = document.createElement('div');
      modal.id = 'pct-upload-regenerate-modal';
      modal.innerHTML = '<div class="pct-upload-regenerate-card" role="dialog" aria-modal="true" aria-labelledby="pct-upload-regenerate-title"><h2 id="pct-upload-regenerate-title">Uploading more photos will regenerate your layout</h2><p>Your current preview will be replaced after the new photos upload. You can cancel if you want to keep this layout.</p><div class="pct-upload-regenerate-actions"><button type="button" data-pct-cancel>Cancel</button><button type="button" data-pct-continue>Continue Uploading</button></div></div>';
      function close(value) {
        modal.remove();
        resolve(value);
      }
      modal.querySelector('[data-pct-cancel]').addEventListener('click', function () { close(false); });
      modal.querySelector('[data-pct-continue]').addEventListener('click', function () { close(true); });
      modal.addEventListener('click', function (event) { if (event.target === modal) close(false); });
      document.body.appendChild(modal);
    });
  };

  window.pctRequestPhotoUpload = async function (options) {
    options = options || {};
    if (isLocked()) return false;
    if (window.isPreviewBuildLocked && window.isPreviewBuildLocked()) return false;
    if (window.uploadBatchInProgress) return false;
    var input = document.getElementById('firebase-file-input');
    if (!input) return false;
    if (!options.skipRegenerateWarning && hasRegeneratingLayout()) {
      var proceed = await window.pctConfirmRegeneratingUpload();
      if (!proceed) return false;
      window.pctPendingUploadWillRegenerate = true;
    } else {
      window.pctPendingUploadWillRegenerate = false;
    }
    input.setAttribute('data-pct-upload-source', options.source || 'builder');
    input.click();
    return true;
  };

  window.pctRequestDsUploadIntent = function (fileCount) {
    return new Promise(function (resolve) {
      var modal = document.createElement('div');
      modal.id = 'pct-ds-intent-modal';
      modal.style.cssText = 'position:fixed;inset:0;z-index:10000056;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;font-family:inherit;padding:22px;';
      modal.innerHTML =
        '<div style="width:min(460px,100%);background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,.22);padding:26px;">' +
          '<h2 style="margin:0 0 8px;font-size:20px;line-height:1.2;color:#151515;">Add photos to your book</h2>' +
          '<p style="margin:0 0 20px;color:#555;font-size:14px;line-height:1.5;">How would you like to continue?</p>' +
          '<div style="display:flex;flex-direction:column;gap:10px;">' +
            '<button type="button" data-di="regenerate" style="border:0;border-radius:12px;padding:14px 16px;font-weight:800;cursor:pointer;text-align:left;background:#2C3E35;color:#fff;">' +
              'Regenerate Layout' +
              '<span style="font-weight:400;font-size:13px;display:block;margin-top:3px;opacity:.8;">Recommended — close the editor and rebuild the layout with all your photos.</span>' +
            '</button>' +
            '<button type="button" data-di="editor-only" style="border:1px solid #ddd;border-radius:12px;padding:14px 16px;font-weight:800;cursor:pointer;text-align:left;background:#f7f7f7;color:#151515;">' +
              'Add to Editor Only' +
              '<span style="font-weight:400;font-size:13px;display:block;margin-top:3px;color:#666;">Keep the editor open and place photos manually.</span>' +
            '</button>' +
            '<button type="button" data-di="cancel" style="border:0;padding:10px;font-weight:700;cursor:pointer;background:transparent;color:#888;font-size:13px;">Cancel</button>' +
          '</div>' +
        '</div>';
      function close(value) { modal.remove(); resolve(value); }
      modal.querySelector('[data-di="regenerate"]').addEventListener('click', function () { close('regenerate'); });
      modal.querySelector('[data-di="editor-only"]').addEventListener('click', function () { close('editor-only'); });
      modal.querySelector('[data-di="cancel"]').addEventListener('click', function () { close(null); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(null); });
      document.body.appendChild(modal);
    });
  };

  window.pctShowDsFallbackPrompt = function () {
    return new Promise(function (resolve) {
      var modal = document.createElement('div');
      modal.id = 'pct-ds-fallback-modal';
      modal.style.cssText = 'position:fixed;inset:0;z-index:10000056;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;font-family:inherit;padding:22px;';
      modal.innerHTML =
        '<div style="width:min(420px,100%);background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,.22);padding:26px;">' +
          '<h2 style="margin:0 0 8px;font-size:20px;color:#151515;">Couldn\'t add dropped photos</h2>' +
          '<p style="margin:0 0 22px;color:#555;font-size:14px;line-height:1.5;">Your browser doesn\'t support uploading dropped photos here. Use Browse photos instead.</p>' +
          '<div style="display:flex;justify-content:flex-end;gap:10px;">' +
            '<button type="button" data-fb="cancel" style="border:0;border-radius:999px;padding:12px 18px;font-weight:800;cursor:pointer;background:#f1f1f1;color:#111;">Cancel</button>' +
            '<button type="button" data-fb="browse" style="border:0;border-radius:999px;padding:12px 18px;font-weight:800;cursor:pointer;background:#2C3E35;color:#fff;">Browse photos</button>' +
          '</div>' +
        '</div>';
      function close(value) { modal.remove(); resolve(value); }
      modal.querySelector('[data-fb="cancel"]').addEventListener('click', function () { close(false); });
      modal.querySelector('[data-fb="browse"]').addEventListener('click', function () { close(true); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(false); });
      document.body.appendChild(modal);
    });
  };
})();
